import { Component, OnInit, Input } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';
import * as moment from 'moment';

import 'moment/locale/pt-br';

// Service
import { CockpitService } from '../../../service/cockpit/cockpit.service';

@Component({
	selector: 'app-credit-proposal',
	templateUrl: './credit-proposal.component.html',
	providers: [
		CockpitService,
		HttpModule
	]
})
export class CockpitCreditProposalComponent implements OnInit {

	@Input('follow') follow: boolean;

	public myOrdersResponsable: any[] = [];
	public orderby: string = "Data";
	public sort: string = "asc";
	public defaultOrder: boolean = true;

	constructor(private CockpitService: CockpitService, private router: Router, private route: ActivatedRoute, private flashMessagesService: FlashMessagesService) {
	}

	ngOnInit() {
		if (this.follow) {
			this.getUserOrdersFollow();
		} else {
			this.getUserOrdersResponsable();
		}
	}

	setOrder(orderby) {
		this.defaultOrder = false;
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc"; 
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		
		if (this.follow) {
			this.getUserOrdersFollow();
		} else {
			this.getUserOrdersResponsable();
		}
	}

	getUserOrdersResponsable() {
		this.CockpitService.getUserOrdersResponsable(this.orderby, this.sort, this.defaultOrder).subscribe(result => {
			if (result.Success) {
				this.myOrdersResponsable = result.Result;

				for (var key in this.myOrdersResponsable) {
					var obj = this.myOrdersResponsable[key];

					if ((obj.Data > moment().startOf('isoWeek').format("YYYY-MM-DD HH:mm:ss") && obj.Data < moment().endOf('isoWeek').format("YYYY-MM-DD HH:mm:ss")) ||
						obj.Data < moment().format("YYYY-MM-DD HH:mm:ss")) {
						obj.Atrasado = true;
					} else if (obj.Data > moment().startOf('isoWeek').format("YYYY-MM-DD HH:mm:ss") && obj.Data < moment().add(1, 'weeks').endOf('isoWeek').format("YYYY-MM-DD HH:mm:ss")) {
						obj.QuaseAtrasado = true;
					}
				}

			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	getUserOrdersFollow() {
		this.CockpitService.getUserOrdersFollow(this.orderby, this.sort, this.defaultOrder).subscribe(result => {
			if (result.Success) {
				this.myOrdersResponsable = result.Result;

				for (var key in this.myOrdersResponsable) {
					var obj = this.myOrdersResponsable[key];

					if ((obj.Data > moment().startOf('isoWeek').format("YYYY-MM-DD HH:mm:ss") && obj.Data < moment().endOf('isoWeek').format("YYYY-MM-DD HH:mm:ss")) ||
						obj.Data < moment().format("YYYY-MM-DD HH:mm:ss")) {
						obj.Atrasado = true;
					} else if (obj.Data > moment().startOf('isoWeek').format("YYYY-MM-DD HH:mm:ss") && obj.Data < moment().add(1, 'weeks').endOf('isoWeek').format("YYYY-MM-DD HH:mm:ss")) {
						obj.QuaseAtrasado = true;
					}
				}

			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/cockpit/component/cockpit/credit-proposal/credit-proposal.component.ts